class ScanTimeoutErrorResponse {
  name: string;

  constructor() {
    this.name = "ScanTimeoutErrorResponse";
  }
}

export default ScanTimeoutErrorResponse;
